import { DEFAULT_LANGUAGE } from 'constants/project';

export default localStorage.getItem('lang') || DEFAULT_LANGUAGE;
